import { inject, injectable } from 'inversify';
import NPSService from '../../data/service/NPSService';
import {
  GetNPSByUserUuidRequest,
  GetNPSByUserUuidResponse,
} from '../../data/service/NPSService.types';

@injectable()
class GetNPSByUserUuidUseCase {
  @inject(NPSService) private npsService!: NPSService;

  async execute(
    params: GetNPSByUserUuidRequest
  ): Promise<GetNPSByUserUuidResponse | null> {
    try {
      const response = await this.npsService.getNPSByUserUuid(params);

      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}

export default GetNPSByUserUuidUseCase;
